import client from "./client";
import { API_ENDPOINTS } from "../constants";

const versionCheck = (data) => client.post(API_ENDPOINTS.VERSION_CHECK, data);
const appConfig = (customUrlPath) =>
  client.post(API_ENDPOINTS.APP_CONFIG(customUrlPath));
const customerExists = (data) =>
  client.post(API_ENDPOINTS.CUSTOMER_EXISTS, data);
const registerInitiate = (data) =>
  client.post(API_ENDPOINTS.REGISTER_INITIATE, data);
const loginInitiate = (data) => client.post(API_ENDPOINTS.LOGIN_INITIATE, data);
const registerVerifyOTP = (data) =>
  client.post(API_ENDPOINTS.REGISTER_VERIFY_OTP, data);
const loginVerifyOTP = (data) =>
  client.post(API_ENDPOINTS.LOGIN_VERIFY_OTP, data);
const crLogin = (data) => client.post(API_ENDPOINTS.CR_LOGIN, data);
const customerConsent = (data) =>
  client.post(API_ENDPOINTS.CUSTOMER_CONSENT, data);
const nafathVerification = () =>
  client.post(API_ENDPOINTS.NAFATH_VERIFICATION, {});
const getProfileDetails = () => client.get(API_ENDPOINTS.PROFILE_DETAILS);
const registerSetPin = (data) =>
  client.post(API_ENDPOINTS.REGISTER_SET_PIN, data);
const loginSetPin = (data) => client.post(API_ENDPOINTS.LOGIN_SET_PIN, data);
const forgotPasswordInitiate = (data) =>
  client.post(API_ENDPOINTS.FORGOT_PASSWORD_INITIATE, data);
const forgotPasswordVerifyOTP = (data) =>
  client.post(API_ENDPOINTS.FORGOT_PASSWORD_VERIFY_OTP, data);
const forgotPasswordSetPin = (data) =>
  client.post(API_ENDPOINTS.FORGOT_PASSWORD_SET_PIN, data);
const Logout = () => client.delete(API_ENDPOINTS.LOGOUT);
const refreshToken = () => client.post(API_ENDPOINTS.REFRESH_TOKEN, null);
const getUserDetails = () => client.get(API_ENDPOINTS.ME);
const changePasswordInitiate = (data) =>
  client.post(API_ENDPOINTS.CHANGE_PASSWORD_INITIATE, data);
const changePasswordVerifyOTP = (data) =>
  client.post(API_ENDPOINTS.CHANGE_PASSWORD_VERIFY_OTP, data);
const changePasswordSetPin = (data) =>
  client.post(API_ENDPOINTS.CHANGE_PASSWORD_SET_PIN, data);
const completeFinanceJourney = ({ params, data }) =>
  client.post(
    API_ENDPOINTS.COMPLETE_FINANCE({
      requestId: params?.requestId,
      taskId: params?.taskId,
    }),
    data
  );
const backFinanceJourney = ({ params }) =>
  client.post(
    API_ENDPOINTS.FINANCE_BACK_TASK({
      requestId: params?.requestId,
      taskId: params?.taskId,
    })
  );
const updateUserDetails = (data) => client.put(API_ENDPOINTS.ME, data);
const getFinanceApplications = (id) =>
  client.get(API_ENDPOINTS.FINANCE_APPLICATIONS(id));
const merchantOnboardingStatus = () =>
  client.post(API_ENDPOINTS.MERCHANT_ONBOARDING_STATUS, null);
const financeApplicationStatus = () =>
  client.post(API_ENDPOINTS.FINANCE_APPLICATION_STATUS, null);
const getFinanceNextTask = (requestId) =>
  client.get(API_ENDPOINTS.FINANCE_NEXT_TASK(requestId));
const authBackSession = () => client.post(API_ENDPOINTS.AUTH_BACK_SESSION);
const currentApplicationFlow = (data) =>
  client.post(API_ENDPOINTS.CURRENT_APPLICARION_WORKFLOW, data);
const login = (data) => client.post(API_ENDPOINTS.LOGIN, data);
const validateLogin = (data) =>
  client.post(API_ENDPOINTS.LOGIN_CALL_BACK, data);
const partnerLogin = (data) => client.post(API_ENDPOINTS.PARTNER_LOGIN, data);
const generateUploadUrl = ({ payload, applicationId }) =>
  client.post(API_ENDPOINTS.UPLOAD_URL(applicationId), payload);
const uploadFile = ({ url, file }) => client.put(url, file);
const uploadDocumentComplete = ({ data, params }) =>
  client.post(API_ENDPOINTS.UPLOAD_DOCUMENT_COMPLETION(params), data);
const getCampaignScreen = (campaignSlug) =>
  client.get(API_ENDPOINTS.CAMPAIGN_SCREEN(campaignSlug));
const getConnectAuth = (data) => client.post(API_ENDPOINTS.AUTH_CONNECT, data);
const verifyShortLink = (code) =>
  client.get(API_ENDPOINTS.SHORT_LINK_VERIFY(code));
const verifyOtp = (data) => client.post(API_ENDPOINTS.VERIFY_OTP, data);
const getDocumentList = ({ applicationId }) =>
  client.get(API_ENDPOINTS.GET_DOCUMENT_LIST(applicationId));
const deleteDocument = ({ applicationId, documentId }) =>
  client.delete(API_ENDPOINTS.DELETE_DOCUMENT({ applicationId, documentId }));
const distributorLogin = (data) =>
  client.post(API_ENDPOINTS.DISTRIBUTOR_LOGIN, data);
const distributorVerifyOtp = (data) =>
  client.post(API_ENDPOINTS.DISTRIBUTOR_VERIFY_OTP, data);

const api = {
  versionCheck,
  appConfig,
  customerExists,
  registerInitiate,
  loginInitiate,
  registerVerifyOTP,
  loginVerifyOTP,
  getProfileDetails,
  registerSetPin,
  loginSetPin,
  forgotPasswordInitiate,
  forgotPasswordVerifyOTP,
  forgotPasswordSetPin,
  Logout,
  refreshToken,
  getUserDetails,
  changePasswordInitiate,
  changePasswordVerifyOTP,
  changePasswordSetPin,
  completeFinanceJourney,
  updateUserDetails,
  getFinanceApplications,
  merchantOnboardingStatus,
  financeApplicationStatus,
  getFinanceNextTask,
  authBackSession,
  backFinanceJourney,
  crLogin,
  customerConsent,
  nafathVerification,
  currentApplicationFlow,
  login,
  validateLogin,
  partnerLogin,
  generateUploadUrl,
  uploadFile,
  uploadDocumentComplete,
  getCampaignScreen,
  getConnectAuth,
  verifyShortLink,
  verifyOtp,
  getDocumentList,
  deleteDocument,
  distributorLogin,
  distributorVerifyOtp,
};

export default api;
